import { connect } from 'react-redux';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { ServiceOrderState } from '@mews-commander/data-access';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { getGroupNonCanceledReservationsCount } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { ApplicationState } from '@mews-commander/types';
import { useGroupReservationsQuery } from '@mews-commander/core/entities';

interface Props {
    count: number;
}

interface OwnProps {
    groupId: string;
}

const GroupTabLabel: React.FC<OwnProps> = ({ groupId }: OwnProps) => {
    const { data: count } = useGroupReservationsQuery(groupId, {
        select: ({ reservations }) =>
            reservations?.filter((r) => r.serviceOrderState !== ServiceOrderState.Canceled).length,
    });
    return (
        <span>
            <LocalizedText textKey={TextKey.Group} />
            {count ? (
                <>
                    {UnicodeEntity.NoBreakSpace}
                    {UnicodeEntity.LeftParenthesis}
                    {count}
                    {UnicodeEntity.RightParenthesis}
                </>
            ) : null}
        </span>
    );
};
const GroupTabLabelOld: React.FC<Props> = ({ count }) => (
    <span>
        <LocalizedText textKey={TextKey.Group} />
        {count ? (
            <>
                {UnicodeEntity.NoBreakSpace}
                {UnicodeEntity.LeftParenthesis}
                {count}
                {UnicodeEntity.RightParenthesis}
            </>
        ) : null}
    </span>
);
const ConnectedGroupTabLabelOld = connect<Props, {}, OwnProps, ApplicationState>((state, { groupId }) => {
    const enterpriseId = getCurrentEnterpriseId();
    return {
        count: getGroupNonCanceledReservationsCount(state, {
            enterpriseId,
            groupId,
        }),
    };
})(GroupTabLabelOld);
export default ({ groupId }: OwnProps) => {
    const reservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    return reservationModuleReactQueryEnabled ? (
        <GroupTabLabel groupId={groupId} />
    ) : (
        <ConnectedGroupTabLabelOld groupId={groupId} />
    );
};
